import { useEffect, useState } from 'react'
import RULES from './../mocks/rules.json'
import { DataRule } from '../rules.types'

export const useRules = () => {
  const [data, setData] = useState<DataRule[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | string | null>(null)

  const fetchDatasetVersions = async () => {
    setLoading(true)
    setError(null)

    try {
      const delay = 1000 * Math.floor(Math.random() * 4) + 1
      const mock = await new Promise(resolve => setTimeout(resolve, delay, RULES))

      if (mock) return setData(mock as DataRule[])
    } catch (err: unknown) {
      setError((err as Error)?.message || 'An unknown error occurred')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDatasetVersions()
  }, [])

  return { data, loading, error }
}
